var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersEvent,"items":_vm.auditEvents,"show-expand":"","loading":_vm.isLoading},scopedSlots:_vm._u([{key:"item.timeStamp",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(item.timeStamp.toLocaleString()))])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('v-data-table',{attrs:{"items":item.changes,"headers":_vm.headersChange,"hide-default-footer":"","single-expand":"","dense":""},scopedSlots:_vm._u([{key:"item.keyValues",fn:function(ref){
var item = ref.item;
return [_c('VueJsonPretty',{attrs:{"data":_vm.parse(item.keyValues),"showDoubleQuotes":false}})]}},{key:"item.oldValues",fn:function(ref){
var item = ref.item;
return [_c('VueJsonPretty',{attrs:{"data":_vm.parse(item.oldValues),"showDoubleQuotes":false}})]}},{key:"item.newValues",fn:function(ref){
var item = ref.item;
return [_c('VueJsonPretty',{attrs:{"data":_vm.parse(item.newValues),"showDoubleQuotes":false}})]}}],null,true)})],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }